import { render } from "./SettingsGroup.vue?vue&type=template&id=d605d81e&scoped=true&ts=true"
import script from "./SettingsGroup.vue?vue&type=script&lang=ts"
export * from "./SettingsGroup.vue?vue&type=script&lang=ts"

import "./SettingsGroup.vue?vue&type=style&index=0&id=d605d81e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d605d81e"]])

export default __exports__